import { useState, useEffect } from "react";
import emailjs, { init } from "@emailjs/browser";
init(process.env.userID);

export const useSendEmail = (data, completeData) => {
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [pending, setPending] = useState(false);

  useEffect(() => {

    function sendMessage() {
      setPending(true);
      emailjs
        .send("service_4ze4tld", "Formulaire de contact", {
          name: data.name,
          mail: data.mail,
          message: data.message,
        })
        .then((res) => {
          console.log("SUCCESS!", res.status, res.text);
          setSuccess(true)
        })
        .catch((error) => {
          console.log("Error", error);
          setError(true)
        }).finally(() => {

          setPending(false)
          setSuccess(false)
          setError(false)
        });

    }

    if (data && completeData && !pending) {
      sendMessage()
    }
  }, [completeData]);

  return [success, pending, error]
};
